module.exports = __webpack_public_path__ + "static/img/planet5.c34ac93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/planet/planet5.png
// module id = xFvg
// module chunks = 1